export default class NotificationsPresenter {
    present (notifications = []) {
        let presented = []

        notifications.sort((a, b) => {
            return a.created_at < b.created_at ? 1 : -1
        })

        for (let notification of notifications) {
            let block = presented.find(block => block.key === notification.chunk_key)

            if (block === undefined) {
                block = {
                    key: notification.chunk_key,
                    chunks: []
                }

                presented.push(block)
            }

            let chunk = this.findOrCreateChunk(block, notification.job || null)

            chunk.notifications.push(notification)
        }

        return presented
    }

    findOrCreateChunk (block, job) {
        let newChunk = {
            job,
            notifications: []
        }

        let lastChunk = block.chunks[block.chunks.length - 1]

        if (lastChunk && lastChunk.job && job && lastChunk.job.id === job.id) {
            return lastChunk
        }

        block.chunks.push(newChunk)

        return newChunk
    }
}
